import AutoOption from './AutoOption';

export default AutoOption;
